import React from "react";
import { Box, Portal, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Triangle } from "react-loader-spinner";
// import theme from "../../theme";

const useStyle = makeStyles(() => {
  return {
    childDiv: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
    },
    parent: {
      position: "fixed",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      background: "rgba(0, 0, 0, 0.26)",
      transition: "opacity 500ms",
      zIndex: 9999,
    },
  };
});

function Loader() {
  const { parent, childDiv } = useStyle();
  const theme = useTheme();
  const primaryColor =
    theme?.palette?.primary?.main?.replace("!important", "").trim() || "#298b8b";

  return (
    <Portal>
      <Box className={parent}>
        <Box className={childDiv}>
          <Triangle
            sx={{ color: primaryColor }}
            height="100"
            width="100"
            color={primaryColor}
            secondaryColor={primaryColor}
            ariaLabel="triangle-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </Box>
      </Box>
    </Portal>
  );
}

export default Loader;

// import React, { useContext } from "react";
// import { Box } from "@mui/material";
// import { makeStyles } from "@mui/styles";
// import { Triangle } from "react-loader-spinner";
// import theme from "../../theme";
// import { SideBarContext } from "../../Context/SideBarContext/SideBarContext";
// import { drawerWidth } from "../SideBar/SideBar";

// const useStyle = makeStyles(() => {
//   return {
//     childDiv: {
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       width: "100%",
//       height: "100%",
//     },
//     parent: {
//       position: "fixed",
//       top: "0",
//       bottom: "0",
//       left: "0",
//       right: "0",
//       width: "100vw",
//       height: "100vh",
//       background: "rgba(0, 0, 0, 0.26)",
//       transition: "opacity 500ms",
//       padding: " 60px",
//       zIndex: 9999,
//     },
//   };
// });
// function Loader() {
//   const { parent, childDiv } = useStyle();
//   const { openSidebar } = useContext(SideBarContext);

//   return (
//     <Box
//       className={parent}
//       sx={{
//         marginLeft: `${openSidebar ? `${drawerWidth}px` : `calc(${theme.spacing(6)} + 1px)`
//           }`,
//       }}
//     >
//       <Box className={childDiv}>
//         <Triangle
//           sx={{ color: (theme) => theme.palette.primary.main }}
//           height="100"
//           width="100"
//           color="#298b8b"
//           secondaryColor="#298b8b"
//           ariaLabel="triangle-loading"
//           wrapperStyle={{}}
//           wrapperClassName=""
//           visible={true}
//         />
//       </Box>
//     </Box>
//   );
// }

// export default Loader;
